var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-radio",attrs:{"role":"group"}},[_vm._l((_vm.options),function({
      checked,
      inputKey,
      labelKey,
      title,
      value,
    }){return [_c('input',{key:inputKey,staticClass:"input-radio__input",attrs:{"type":"radio","id":inputKey,"name":_vm.identifier},domProps:{"checked":checked,"value":value},on:{"input":function($event){return _vm.onInput(value)}}}),_c('label',{key:labelKey,staticClass:"input-radio__title",class:{ checked },attrs:{"for":inputKey}},[_vm._v(_vm._s(title))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }